// 1) hex ↠ [r,g,b] (0–1)
export function hexToRgb (hex) {
  let h = hex.replace('#', '')
  if (h.length === 3) h = h.split('').map(c => c + c).join('')
  const int = parseInt(h, 16)
  return [
    ((int >> 16) & 0xFF) / 255,
    ((int >> 8) & 0xFF) / 255,
    (int & 0xFF) / 255
  ]
}

// 2) linearize and compute luminance
export function luminance ([r, g, b]) {
  const chan = c => {
    return c <= 0.03928
      ? c / 12.92
      : Math.pow((c + 0.055) / 1.055, 2.4)
  }
  const R = chan(r)
  const G = chan(g)
  const B = chan(b)
  return 0.2126 * R + 0.7152 * G + 0.0722 * B
}

// 3) contrast ratio between two luminances L1 ≥ L2
export function contrast (L1, L2) {
  return (L1 + 0.05) / (L2 + 0.05)
}

// 4) combo: hex vs white or black
export function contrastAgainst (hex, target = 'white') {
  const L = luminance(hexToRgb(hex))
  const Lt = target === 'white' ? 1 : 0
  return contrast(Math.max(L, Lt), Math.min(L, Lt))
}

export function getContrast (hex) {
  return {
    lightRatio: contrastAgainst(hex, 'white'),
    darkRatio: contrastAgainst(hex, 'black')
  }
}
